// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1E8PN","amount":"Amount_amount__2FMFm","tip":"Amount_tip__3sXxv","tipHeader":"Amount_tipHeader__2dP-p","tipsWrap":"Amount_tipsWrap__BBlqN"};